<template>
  <section class="google-places px-6 md:px-16 pb-36">
    <div class="tabs">
      <div
        v-if="places !== undefined"
        class="tabs"
      >
        <div
          v-for="place in places"
          :key="place.id"
          class="tab"
          @click="openModal(place)"
          ref="tabs"
        >
          <div class="heading">
            <h2>{{ place.title }}</h2>

            <div v-if="place.details.length" class="details">
              <p class="subtitle">
                {{ place.details[0].subtitle }}
              </p>

              <p class="eta">
                {{ place.details[0].walkingEta }}
              </p>
            </div>
          </div>

          <div class="indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none">
              <path fill="#29261E" d="M0 8V6h12L8 2l1-2 7 7-7 7-1-2 4-4H0z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <PlacesModal :modal="activeModal" @visiblePlace="openModal" @modalClosed="openModal" :places="places" />
  </section>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';
import PlacesModal from './PlacesModal.vue';

export default {
  name: 'GooglePlaces',
  props: {
    modal: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    PlacesModal
  },
  data () {
    return {
      activeModal: '',
      places: []
    }
  },
  mounted () {
    this.fetchResults()
  },
  methods: {
    async fetchResults() {
      let type = window.location.pathname.split("/").pop().split('-')

      if (type.length > 1) {
        type = `${type[0]}${type[1].replace(/^\w/, (c) => c.toUpperCase())}`
      }

      if (type === 'shopsAnd') {
        type = 'retailServices'
      }

      const query = `
        query {
          entries(orderBy: "title", type: "${type}") {
            ... on places_foodDrink_Entry {
              id
              __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_living_Entry {
              id
              __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_retailServices_Entry {
              id
              __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_artsEntertainment_Entry {
              id
              __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
          }
        }
      `;
      let response = await fetch('/api', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query })
      })

      if (response.ok) {
        let json = await response.json();
        this.places = json.data.entries
      }

      return []
    },
    openModal (item) {
      this.activeModal = item.id
      this.$emit('placeClicked', item.id)
    }
  },
  watch: {
    modal (newValue, oldValue) {
      if (newValue !== '') {
        this.activeModal = newValue
      }
    },
    places (newValue) {
      anime({
        delay: anime.stagger(100),
        duration: 300,
        easing: 'easeOutSine',
        targets: document.querySelectorAll('.tabs .tab'),
        opacity: [0, 1],
        translateY: [200, 0]
      });
    }
  }
}
</script>
